export default theme => ({
  names: {
    display: 'flex',
    gap: 10,
    marginBottom: 10
  },
  name: {
    flex: 1,
    minWidth: 0,
    '&:not(:last-child)': {
      marginRight: 10
    }
  },
  info: {
    width: '101%',
    marginBottom: 10
  },
  signIn: {
    fontSize: 10,
    color: theme.grey2
  },
  signupContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 18
  },
  logoWrapper: {
    '& > div': {
      justifyContent: 'flex-start'
    }
  }
});
